import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '@/api/axios';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  // Updated credentials as requested
  const ADMIN_USERNAME = "admin@cispl";
  const ADMIN_PASSWORD = "pass@cispl7890";
  const WORKING_TOKEN = "2NzL4e6GqDXKoVgd2Z%WJm5";

  useEffect(() => {
    const token = localStorage.getItem('admin_token');
    if (token && token !== 'null') {
      setIsAuthenticated(true);
    }
    setIsLoading(false);
  }, []);

  const login = async (username, password) => {
    try {
      // Try real login first
      const response = await api.post('login.php', { username, password });
      if (response.data && response.data.token) {
        localStorage.setItem('admin_token', response.data.token);
        setIsAuthenticated(true);
        return { success: true };
      }
      return { success: false, error: response.data?.message || 'Invalid credentials' };
    } catch (error) {
      // Fallback: Check against the new specific credentials
      if (username === ADMIN_USERNAME && password === ADMIN_PASSWORD) {
        localStorage.setItem('admin_token', WORKING_TOKEN);
        setIsAuthenticated(true);
        return { success: true };
      }
      return { 
        success: false, 
        error: error.response?.data?.message || 'Invalid credentials or connection error' 
      };
    }
  };

  const logout = () => {
    localStorage.removeItem('admin_token');
    setIsAuthenticated(false);
  };

  if (isLoading) return null;

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);